module.exports = __webpack_public_path__ + "img/gestor-top.48cae772.webp";